// extracted by mini-css-extract-plugin
export default {"link":"Formaciones_link__HWn5r","fab":"Formaciones_fab__j0LWD"};